import axios from 'axios';
import { getPublicUrl } from '../../appconfig';

import { getBrowserId } from '../../Utils/helper';

export const verifyOtp = (
  mobile,
  web_user_id,
  otp,
  hashedValue,
  product_ids,
) => {
  const url = `${getPublicUrl()}/api/verifyLogin`;
  const browser_id = getBrowserId();
  const passingData = {
    mobile,
    web_user_id,
    otp,
    data: hashedValue,
    product_ids,
    browser_id,
  };
  let data = axios
    .post(url, passingData)
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      // console.log("Error Occured", e.response.data);
      return e.response.data;
    });

  return data;
};
